import { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
// Components styles
import { Page, CustomDialog as Dialog } from 'components';
import { Image } from 'mui-image';
import { v4 } from 'uuid';
// Sections for this page
import HomePage from './sections/HomePage';
import Header from './sections/Header';
import CustomJs from './sections/CustomJs';
import EnquiryImage from '../../assets/img/enquiry1.png';
import EnquiryForm from './sections/enquiryForm';

const useStyle = makeStyles(() => ({
  relative: {
    position: 'relative'
  },
  enquiryStyle: {
    position: 'fixed',
    right: 10,
    bottom: 10,
    width: 70,
    height: 70,
    cursor: 'pointer'
  }
}));

export default function LandingPage() {
  const [showDialog, setShowDialog] = useState(false);
  const classes = useStyle();
  useEffect(() => {
    CustomJs();
  });
  const openForm = () => {
    setShowDialog(v4());
  };
  const onSubmitForm = () => {
    setShowDialog(undefined);
  };
  return (
    <Page title="Navira Live | Best platform for competitive exam" className={classes.relative}>
      <Header />
      <Dialog
        id={showDialog}
        open={showDialog}
        component={<EnquiryForm onSubmit={onSubmitForm} onCancel={onSubmitForm} />}
        maxWidth="sm"
        disableEscKey
        disableBackDrop
      />
      <HomePage />
      <Image
        sx={{
          width: '80px !important',
          height: '80px !important',
          cursor: 'pointer !important',
          position: 'fixed !important',
          bottom: 10,
          right: 10
        }}
        src={EnquiryImage}
        alt="enquiryImage"
        onClick={openForm}
      />
    </Page>
  );
}
